// extracted by mini-css-extract-plugin
export var chevronIcon = "_av-2";
export var teamName = "_av-1";
export var teamSwitcherButton = "_av-0";